
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Iconify from 'src/components/Iconify';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

//mui
import { Box, Stack, Container, Stepper, Step, StepLabel } from '@mui/material';
//zui 
import { Button } from 'src/@/components/ui/button';
import { Card, CardContent } from 'src/@/components/ui/card';
// actions


//components
import AiAgentTraining from './tabs/AiAgentTraining';
import AiAgentProfileTab from './tabs/AiAgentProfileTab';
import AiAgentConfigTab from './tabs/AiAgentConfigTab';
import AiSelectPromptType from './tabs/AiSelectPromptType';
import AiAgentPromptTab from './tabs/AiAgentPromptTab';
import useAuth from 'src/hooks/useAuth';
import Scrollbar from 'src/components/Scrollbar';


//actions
import v2_actionCalendarios from 'src/actions/v2/calendario/v2_actionCalendarios';
import v2_actionEditarAgenteAi from 'src/actions/v2/ai/v2_actionEditarAgenteAi';
import v2_actionAiConfig from 'src/actions/v2/ai/v2_actionAiConfig';
import v2_actionAgenteAi from 'src/actions/v2/ai/v2_actionAgenteAi';


export default function ConfigAgentesIaComponent() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation('settings');
    const [activeStep, setActiveStep] = useState(0);
    const [skipped, setSkipped] = useState(new Set());
    const [config, setConfig] = useState(null);
    const [aiAgent, setAiAgent] = useState(null);
    const [calendars, setCalendars] = useState([]);
    const { cliente, user } = useAuth();

    const steps = [
        t('aiAgents.wizard.stepScope', 'Escopo'),
        t('aiAgents.wizard.stepProfile', 'Perfil'),
        t('aiAgents.wizard.stepPrompt', 'Prompt'),
        t('aiAgents.wizard.stepConfig', 'Configurações'),
        t('aiAgents.wizard.stepTraining', 'Treinamento'),
    ];

    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('id');


    async function buscarConfigAi() {
        try {
            const response = await v2_actionAiConfig(cliente._id);
            setConfig(response.data.data)
        } catch (error) {
        }
    }

    async function getListCalendars() {
        try {
            const response = await v2_actionCalendarios(cliente._id)
            if (response.status === 200) {
                setCalendars(response.data.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    async function buscarAgenteAi(id) {
        try {
            const response = await v2_actionAgenteAi(id);
            setAiAgent(response.data.data)
        } catch (error) {

        }
    }

    async function handleEditarAgenteAi() {
        try {
            let data = {
                action: "update",
                scope: aiAgent
            }
            await v2_actionEditarAgenteAi(aiAgent._id, data);
            navigate('/dashboard/configuracoes/agentes-ia')
        } catch (error) {
            enqueueSnackbar(t('aiAgents.wizard.toastEditError', 'Erro ao editar agente'), { variant: 'error' })
        }
    }


    useEffect(() => {
        buscarAgenteAi(code)
        buscarConfigAi();
        getListCalendars();
        return () => {
            setAiAgent(null)
            setConfig(null)
        }
    }, [code])


    const handleNext = async () => {
        // finalizar
        if (activeStep === steps.length - 1) {
            await handleEditarAgenteAi();
            enqueueSnackbar(t('aiAgents.wizard.toastEditSuccess', 'Agente editado com sucesso'), { variant: 'success' });
            buscarAgenteAi(code)
            return;
        }

        // verificar se  campos company name, name,  persona estão preenchidos
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };


    return (
        <div className='w-full h-full flex flex-col justify-between'>
            <Container maxWidth="xl">
                <Stack>
                    <Box sx={{ width: '100%' }}>
                        <Stack direction={"row"} justifyContent={"space-between"}>
                            <Stack spacing={1} alignItems={"center"} direction={"row"}>
                                <Button
                                    size='icon'
                                    variant='outline'
                                    onClick={
                                        () => {
                                            navigate('/dashboard/configuracoes/agentes-ia')
                                        }}
                                >
                                    <Iconify icon="majesticons:arrow-left" color="black" />

                                </Button>
                                <p>{t('aiAgents.wizard.backToAgentsLink', 'voltar aos agentes')}</p>
                            </Stack>

                        </Stack>
                    </Box>
                    <div className='h-[80vh] flex items-center justify-center'>
                        <Card className="w-full">
                            <div className="p-3 bg-slate-300">
                                <Stepper activeStep={activeStep}>
                                    {steps.map((label, index) => {
                                        const stepProps = {};
                                        const labelProps = {};
                                        return (
                                            <Step key={label} {...stepProps}>
                                                <StepLabel {...labelProps}>{label}</StepLabel>
                                            </Step>
                                        );
                                    })}
                                </Stepper>
                            </div>

                            <div className="h-[70vh] w-full flex justify-center items-center bg-slate-100">
                                {activeStep === 0 && (
                                    <div className='md:container'>
                                        <AiSelectPromptType
                                            source="stepByStep"
                                            changePromptType={(value) => {
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        generalConfig: {
                                                            ...aiAgent.config.generalConfig,
                                                            type: value,
                                                        },
                                                    },
                                                })

                                            }

                                            }
                                            aiAgent={aiAgent}
                                        />
                                    </div>
                                )}
                                {activeStep === 1 && (
                                    <div className='md:container'>

                                        <AiAgentProfileTab
                                            aiAgent={aiAgent}
                                            config={config}
                                            changeName={(value) =>
                                                setAiAgent({
                                                    ...aiAgent,
                                                    name: value
                                                })
                                            }
                                            changeCompanyName={(value) =>
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        promptGuide: {
                                                            ...aiAgent.config.promptGuide,
                                                            companyName: value,
                                                        },
                                                    },
                                                })
                                            }
                                            changePersona={(value) =>
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        promptGuide: {
                                                            ...aiAgent.config.promptGuide,
                                                            persona: value,
                                                        },
                                                    },
                                                })
                                            }
                                            changeTemperature={(value) => {
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        generalConfig: {
                                                            ...aiAgent.config.generalConfig,
                                                            temperature: value[0],
                                                        },
                                                    },
                                                })
                                                console.log(value)
                                            }

                                            }
                                            changeAgentFunction={(value) => {
                                                console.log(value);
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        generalConfig: {
                                                            ...aiAgent.config.generalConfig,
                                                            agent_function_id: value,
                                                        },
                                                    },
                                                });
                                            }}
                                            changeTypeCommunication={(value) =>
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        promptGuide: {
                                                            ...aiAgent.config.promptGuide,
                                                            type_speaking_id: value,
                                                        },
                                                    },
                                                })
                                            }
                                            changeBusinessActivity={(value) =>
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        promptGuide: {
                                                            ...aiAgent.config.promptGuide,
                                                            business_activities_id: value,
                                                        },
                                                    },
                                                })
                                            }
                                            changeAgentTypeSpeaking={(value) =>
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        promptGuide: {
                                                            ...aiAgent.config.promptGuide,
                                                            type_speaking_id: value,
                                                        },
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                )}
                                {activeStep === 2 && (
                                    <AiAgentPromptTab
                                        prompt={aiAgent?.config?.promptGuide?.prompt}
                                        aiAgent={aiAgent}
                                        changePrompt={(value) => {
                                            if (aiAgent?.config?.generalConfig.type === "promptFree") {
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        promptFree: {
                                                            ...aiAgent.config.promptFree,
                                                            prompt: value,
                                                        },
                                                    },
                                                });
                                            } else {
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        promptGuide: {
                                                            ...aiAgent.config.promptGuide,
                                                            prompt: value,
                                                        },
                                                    },
                                                });
                                            }

                                        }}
                                    />
                                )}
                                {activeStep === 3 && (
                                                                        

                                    <Scrollbar>
                                        <div className='sm:container my-4'>
                                        <AiAgentConfigTab
                                        user={user}
                                            changeAgentType={(value) =>
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        generalConfig: {
                                                            ...aiAgent.config.generalConfig,
                                                            agent_type: value,
                                                        },
                                                    },
                                                })
                                            }
                                            aiAgent={aiAgent}
                                            awnserAudio={aiAgent?.config?.generalConfig?.awnserAudio}
                                            changeAwnserAudio={(value) =>
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        generalConfig: {
                                                            ...aiAgent.config.generalConfig,
                                                            awnserAudio: value,
                                                        },
                                                    },
                                                })
                                            }
                                            listTypeVoices={config?.voices}
                                            calendars={calendars}
                                            changeListenMsgs={(value) =>
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        generalConfig: {
                                                            ...aiAgent.config.generalConfig,
                                                            timeListenMsgs: value ? Number(value) : value,
                                                        },
                                                    },
                                                })
                                            }
                                            changeDelayBetweenMsgs={(value) =>
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        generalConfig: {
                                                            ...aiAgent.config.generalConfig,
                                                            delayBetweenMsgs: value ? Number(value) : value,
                                                        },
                                                    },
                                                })
                                            }
                                            changeLengthSendVoice={(value) =>
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        generalConfig: {
                                                            ...aiAgent.config.generalConfig,
                                                            lengthSendVoice: value ? Number(value) : value,
                                                        },
                                                    },
                                                })
                                            }
                                            changeLimitSendVoice={(value) =>
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        generalConfig: {
                                                            ...aiAgent.config.generalConfig,
                                                            limitSendVoice: value,
                                                        },
                                                    },
                                                })
                                            }
                                            changeLastContext={(value) => {
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        generalConfig: {
                                                            ...aiAgent.config.generalConfig,
                                                            lastContext: value,
                                                        },
                                                    },
                                                })
                                            }}
                                            changeConfigTools={(event) => {
                                                const { name, value } = event;

                                                if (name === 'toolCalendarStatus') {
            
                                                    setAiAgent({
                                                        ...aiAgent,
                                                        config: {
                                                            ...aiAgent.config,
                                                            generalConfig: {
                                                                ...aiAgent.config.generalConfig,
                                                                tools: {
                                                                    ...aiAgent.config.generalConfig.tools,
                                                                    calendar: {
                                                                        ...aiAgent.config.generalConfig.tools.calendar,
                                                                        status: value
                                                                    }
                                                                }
                                                            },
                                                        },
                                                    })
                                                } else if (name === 'toolCalendarId') {
                                                    setAiAgent({
                                                        ...aiAgent,
                                                        config: {
                                                            ...aiAgent.config,
                                                            generalConfig: {
                                                                ...aiAgent.config.generalConfig,
                                                                tools: {
                                                                    ...aiAgent.config.generalConfig.tools,
                                                                    calendar: {
                                                                        ...aiAgent.config.generalConfig.tools.calendar,
                                                                        calendar_id: value
                                                                    }
                                                                }
                                                            },
                                                        },
                                                    })
                                                } else if (name === "toolCalendarMsgConfirm") {
                                                    setAiAgent({
                                                        ...aiAgent,
                                                        config: {
                                                            ...aiAgent.config,
                                                            generalConfig: {
                                                                ...aiAgent.config.generalConfig,
                                                                tools: {
                                                                    ...aiAgent.config.generalConfig.tools,
                                                                    calendar: {
                                                                        ...aiAgent.config.generalConfig.tools.calendar,
                                                                        toolCalendarMsgConfirm: value
                                                                    }
                                                                }
                                                            },
                                                        },
                                                    })
                                                } else if (name === 'toolServicesStatus') {
            
                                                    setAiAgent({
                                                        ...aiAgent,
                                                        config: {
                                                            ...aiAgent.config,
                                                            generalConfig: {
                                                                ...aiAgent.config.generalConfig,
                                                                tools: {
                                                                    ...aiAgent.config.generalConfig.tools,
                                                                    calendar: {
                                                                        ...aiAgent.config.generalConfig.tools.services,
                                                                        status: value
                                                                    }
                                                                }
                                                            },
                                                        },
                                                    })
                                                } else if (name === "knowledgeCalendarStatus") {
                                                    setAiAgent({
                                                        ...aiAgent,
                                                        config: {
                                                            ...aiAgent.config,
                                                            generalConfig: {
                                                                ...aiAgent.config.generalConfig,
                                                                knowledge: {
                                                                    ...aiAgent.config.generalConfig.knowledge,
                                                                    calendar: {
                                                                        ...aiAgent.config.generalConfig.knowledge?.calendar,
                                                                        status: value
                                                                    }
                                                                }
                                                            },
                                                        },
                                                    })
                                                } else if (name === "knowledgeKnowledgeBaseStatus") {
                                                    setAiAgent({
                                                        ...aiAgent,
                                                        config: {
                                                            ...aiAgent.config,
                                                            generalConfig: {
                                                                ...aiAgent.config.generalConfig,
                                                                knowledge: {
                                                                    ...aiAgent.config.generalConfig.knowledge,
                                                                    knowledgeBase: {
                                                                        ...aiAgent.config.generalConfig.knowledge?.knowledgeBase,
                                                                        status: value
                                                                    }
                                                                }
                                                            },
                                                        },
                                                    })
                                                } else if (name === "knowledgeConversationHistoryStatus") {
                                                    setAiAgent({
                                                        ...aiAgent,
                                                        config: {
                                                            ...aiAgent.config,
                                                            generalConfig: {
                                                                ...aiAgent.config.generalConfig,
                                                                knowledge: {
                                                                    ...aiAgent.config.generalConfig.knowledge,
                                                                    conversationHistory: {
                                                                        ...aiAgent.config.generalConfig.knowledge?.conversationHistory,
                                                                        status: value
                                                                    }
                                                                }
                                                            },
                                                        },
                                                    })
                                                } else if (name === "knowledgeProductsStatus") {
                                                    setAiAgent({
                                                        ...aiAgent,
                                                        config: {
                                                            ...aiAgent.config,
                                                            generalConfig: {
                                                                ...aiAgent.config.generalConfig,
                                                                knowledge: {
                                                                    ...aiAgent.config.generalConfig.knowledge,
                                                                    products: {
                                                                        ...aiAgent.config.generalConfig.knowledge?.products,
                                                                        status: value
                                                                    }
                                                                }
                                                            },
                                                        },
                                                    })
                                                } else if (name === "knowledgeFaqStatus") {
                                                    setAiAgent({
                                                        ...aiAgent,
                                                        config: {
                                                            ...aiAgent.config,
                                                            generalConfig: {
                                                                ...aiAgent.config.generalConfig,
                                                                knowledge: {
                                                                    ...aiAgent.config.generalConfig.knowledge,
                                                                    faq: {
                                                                        ...aiAgent.config.generalConfig.knowledge?.faq,
                                                                        status: value
                                                                    }
                                                                }
                                                            },
                                                        },
                                                    })
                                                } else if (name === "customModelAi") {
                                                    setAiAgent({
                                                        ...aiAgent,
                                                        config: {
                                                            ...aiAgent.config,
                                                            generalConfig: {
                                                                ...aiAgent.config.generalConfig,
                                                                customModelAi: value
                                                            }
                                                        }
                                                    })
                                                }
                                                console.log('customModelAi', event)

                                            }
                                        
                                        }



                                            onChangeMsgs={(event) => {
                                                const { name, value } = event.target;
                                                // estrutura: config.generalConfig.messages.msgBreakFiles
                                                switch (name) {
                                                    case "msgs.msgBreakFiles":
                                                        setAiAgent({
                                                            ...aiAgent,
                                                            config: {
                                                                ...aiAgent.config,
                                                                generalConfig: {
                                                                    ...aiAgent.config.generalConfig,
                                                                    messages: {
                                                                        ...aiAgent.config.generalConfig.messages,
                                                                        msgBreakFiles: value,
                                                                    },
                                                                },
                                                            },
                                                        });
                                                        break;

                                                    case "msgs.msgImages":
                                                        setAiAgent({
                                                            ...aiAgent,
                                                            config: {
                                                                ...aiAgent.config,
                                                                generalConfig: {
                                                                    ...aiAgent.config.generalConfig,
                                                                    messages: {
                                                                        ...aiAgent.config.generalConfig.messages,
                                                                        msgImages: value,
                                                                    }
                                                                },
                                                            },
                                                        });
                                                        break;

                                                    case "msgs.msgBreakAudios":
                                                        console.log('msgBreakAudios', aiAgent.config.generalConfig)
                                                        setAiAgent({
                                                            ...aiAgent,
                                                            config: {
                                                                ...aiAgent.config,
                                                                generalConfig: {
                                                                    ...aiAgent.config.generalConfig,
                                                                    messages: {
                                                                        ...aiAgent.config.generalConfig.messages,
                                                                        msgBreakAudios: value,
                                                                    }
                                                                },
                                                            },
                                                        });
                                                        break;

                                                    default:
                                                        break;
                                                }

                                            }}


                                            changeAllowsInChat={(value) =>
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        generalConfig: {
                                                            ...aiAgent.config.generalConfig,
                                                            allowsInChat: value,
                                                        },
                                                    },
                                                })
                                            }

                                            changeVoice={(value) => {
                                                setAiAgent({
                                                    ...aiAgent,
                                                    config: {
                                                        ...aiAgent.config,
                                                        generalConfig: {
                                                            ...aiAgent.config.generalConfig,
                                                            voice_id: value,
                                                        },
                                                    },
                                                });
                                            }}
                                            voice={aiAgent?.config?.generalConfig?.voice_id}
                                        />
                                               </div>
                                    </Scrollbar>
                
                                )}
                                {activeStep === 4 && <AiAgentTraining />}
                            </div>
                        </Card>
                    </div>
                    <div className="flex flex-row justify-between">

                        <Button
                            variant="outline"
                            disabled={activeStep === 0}
                            onClick={handleBack}

                        >
                            {t('aiAgents.wizard.backButton', 'Voltar')}
                        </Button>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button
                            onClick={handleNext}
                        >
                            {activeStep === steps.length - 1 ? t('aiAgents.wizard.finishButton', 'Finalizar') : t('aiAgents.wizard.nextButton', 'Próximo')}
                        </Button>

                    </div>


                </Stack>
            </Container>
            <Container maxWidth>

            </Container>

        </div>
    );
}
